(() => {
	'use strict';

	const quickViewSelector = '.quick-view';
	const buttonSelector = '[data-quick-add-price]';

	const getQuickView = () => document.querySelector(quickViewSelector);

	const formatPrice = (price) => {
		if (typeof window.btyFormatPrice === 'function') {
			return window.btyFormatPrice(price);
		}

		return '';
	};

	const setButtonLabel = (variant) => {
		const quickView = getQuickView();
		const button = quickView?.querySelector(buttonSelector);

		if (!quickView || !button || !variant) {
			return;
		}

		const label = window.btyStrings?.product?.add_to_cart || 'Add to Cart';
		const outOfStock = window.btyStrings?.product?.out_of_stock || 'Out of stock';

		if (!variant.available) {
			button.textContent = outOfStock;
			return;
		}

		const price = formatPrice(variant.price);
		button.textContent = price ? `${label} - ${price}` : label;
		button.classList.remove('disabled');
	};

	document.addEventListener('product-variant-updated', (event) => {
		if (!document.documentElement.classList.contains('quick-view-open')) {
			return;
		}

		setButtonLabel(event.detail?.selected);
	});

	document.addEventListener('product-quick-viewed', (event) => {
		setButtonLabel(event.detail?.selected);
	});
})();
